import React from "react";
import {
    Grid,
    Typography,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Button
} from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';
import { USER_ROLE } from "types/account";

interface CeaseFromFundDialogProps {
    role: USER_ROLE;
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const getCeaseText = (role: USER_ROLE): string => {
    switch (role) {
        case USER_ROLE.ADMIN:
            return "Cease to be an Admin";
        case USER_ROLE.VIEWER:
            return "Cease to be a Viewer";
        case USER_ROLE.ADVISOR:
            return "Cease to be an Advisor";
        default:
            return "Cease to be a Viewer";
    }
};

export const CeaseFromFundDialog: React.FC<
    CeaseFromFundDialogProps
> = ({ open, onClose, onConfirm, role }) => {
    return (
        <Dialog sx={{ m: 2 }} fullWidth={true}
            maxWidth={'sm'} open={open} onClose={onClose}>

            <DialogTitle sx={{ mt: 3, pl: 4 }}>
                <Typography sx={{ color: "neutral", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} variant='subtitle1'>
                    {getCeaseText(role)}?
                    <IconButton
                        onClick={onClose}
                        sx={{
                            padding: 0,
                            "&:hover": {
                                backgroundColor: "transparent",
                            }
                        }}
                    > <CloseIcon />
                    </IconButton>

                </Typography>
            </DialogTitle>
            <DialogContent sx={{ pl: 4, mb: 3 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={12}>
                        <Typography sx={{ color: "neutral" }} variant='bodyCopyRegular'>
                            You're about to {getCeaseText(role)} for this fund.
                            <br></br>
                            Once you cease, you won't be able to access the fund.

                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} textAlign={'end'}>
                        <Button sx={{ mr: 2 }} variant="text" color='primary' size='large' onClick={(e) => {
                            e.stopPropagation();
                            onClose();
                        }} >
                            Cancel
                        </Button>
                        <Button variant="contained" color='primary' size='large' onClick={(e) => {
                            e.stopPropagation();
                            onConfirm();
                        }}    >
                            {getCeaseText(role)}
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

